import { SpaceType, WorkspaceReservationMethod } from "Services/API/API";

const Descriptions: Record<SpaceType, string> = {
   [SpaceType.Any]: "Any",
   [SpaceType.Meeting]: "Meeting Space",
   [SpaceType.Office]: "Office",
   [SpaceType.Desk]: "Desk",
   [SpaceType.Training]: "Training Room",
   [SpaceType.TeamSpace]: "Suite",
   [SpaceType.PrivateOffice]: "Private Office",
   [SpaceType.EventSpace]: "Event Space",
   [SpaceType.OpenDesk]: "Open Desk",
   [SpaceType.DedicatedDesk]: "Dedicated Desk",
   [SpaceType.Membership]: "Membership",

}

export const MeetingAggregatedSpaceType = [SpaceType.Meeting, SpaceType.EventSpace, SpaceType.Training];

export function getDescription(e: SpaceType) { return Descriptions[e]; }

export function getSpaceTypesForReservationMethod(reservationMethod: WorkspaceReservationMethod): SpaceType[] {
   const result = [SpaceType.Any];

   if (reservationMethod == WorkspaceReservationMethod.Period) {
      result.push(SpaceType.Desk, SpaceType.TeamSpace, SpaceType.PrivateOffice);
   } else {
      result.push(SpaceType.Desk, SpaceType.Office, SpaceType.Meeting, SpaceType.EventSpace);
   }

   return result;
}

export function contains(container: SpaceType, value: SpaceType) {
   return !!(container & value);
}

export function toggle(container: SpaceType, ...values: SpaceType[]): SpaceType {
   const isOn = values.reduce<boolean>((previousResult, spaceType) => previousResult || contains(container, spaceType), false);
   values.forEach(value => container = isOn ? container & ~value : container | value);
   return container;
}

export function isMeetingAggregated(e: SpaceType): boolean {
   return MeetingAggregatedSpaceType.reduce<boolean>((previousResult, spaceType) => previousResult || contains(e, spaceType), false);
}
